module.exports = __webpack_public_path__ + "img/features-bg_6.3357c1cd.png";